import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"
import _imports_0 from '../../assets/GCOIN.png'


const _hoisted_1 = { class: "space-y-8" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "flex justify-center" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "text-center text-xl black-title font-semibold" }, "Send Token")
], -1)
const _hoisted_3 = { class: "flex space-x-4" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", { class: "flex flex-col items-center justify-center" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "black-title w-16" }, "Assets")
], -1)
const _hoisted_5 = { class: "flex items-center space-x-2" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  class: "w-8 h-8"
}, null, -1)
const _hoisted_7 = { class: "flex flex-col" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("span", { class: "text-black font-semibold" }, "GCOIN", -1)
const _hoisted_9 = { class: "text-xs mr-1" }
const _hoisted_10 = { class: "flex space-x-4" }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("div", { class: "flex flex-col items-center justify-center" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "black-title w-16" }, "Amount")
], -1)
const _hoisted_12 = /*#__PURE__*/_createElementVNode("span", { class: "text-xs" }, "GCOIN", -1)
const _hoisted_13 = { class: "flex flex-col space-y-4" }
const _hoisted_14 = /*#__PURE__*/_createElementVNode("span", { class: "text-center text-xl font-semibold my-4" }, "To", -1)
const _hoisted_15 = { class: "flex space-x-4" }
const _hoisted_16 = /*#__PURE__*/_createElementVNode("div", { class: "flex flex-col items-center justify-center" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "black-title w-20" }, "Account ID")
], -1)
const _hoisted_17 = { class: "flex space-x-8 items-center" }
const _hoisted_18 = /*#__PURE__*/_createElementVNode("span", { class: "black-title w-16" }, "Remark", -1)
const _hoisted_19 = { class: "flex justify-center" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_a_card = _resolveComponent("a-card")!
  const _component_a_input_number = _resolveComponent("a-input-number")!
  const _component_caret_down_filled = _resolveComponent("caret-down-filled")!
  const _component_a_select = _resolveComponent("a-select")!
  const _component_a_input = _resolveComponent("a-input")!
  const _component_a_alert = _resolveComponent("a-alert")!
  const _component_a_drawer = _resolveComponent("a-drawer")!

  return (_openBlock(), _createBlock(_component_a_drawer, {
    title: "",
    placement: _ctx.placement,
    visible: _ctx.visible,
    height: "75%",
    destroyOnClose: ""
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _hoisted_2,
        _createElementVNode("div", _hoisted_3, [
          _hoisted_4,
          _createVNode(_component_a_card, {
            loading: _ctx.loading,
            class: "ggm-card w-full"
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_5, [
                _hoisted_6,
                _createElementVNode("div", _hoisted_7, [
                  _hoisted_8,
                  _createElementVNode("span", _hoisted_9, "Balance: " + _toDisplayString(_ctx.balanceFormat(_ctx.balanceInfo?.account?.assets[0]?.amount)), 1)
                ])
              ])
            ]),
            _: 1
          }, 8, ["loading"])
        ]),
        _createElementVNode("div", _hoisted_10, [
          _hoisted_11,
          _createVNode(_component_a_input_number, {
            style: {"width":"80%"},
            class: "a-input",
            value: _ctx.amountValue,
            "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.amountValue) = $event)),
            controls: false,
            onFocus: _ctx.focus
          }, {
            addonAfter: _withCtx(() => [
              _hoisted_12
            ]),
            _: 1
          }, 8, ["value", "onFocus"]),
          _createElementVNode("div", {
            class: "max-button rounded-3xl px-2 py-1",
            onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.handleMaxClick && _ctx.handleMaxClick(...args)))
          }, " MAX ")
        ]),
        _createElementVNode("div", _hoisted_13, [
          _hoisted_14,
          _createElementVNode("div", _hoisted_15, [
            _hoisted_16,
            _createVNode(_component_a_select, {
              value: _ctx.accountIdValue,
              "onUpdate:value": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.accountIdValue) = $event)),
              "show-search": "",
              class: "w-60 a-select",
              allowClear: "",
              options: _ctx.data1,
              filterOption: false,
              onSearch: _ctx.myhandleSearch,
              onChange: _ctx.myhandleChange,
              onFocus: _ctx.focus
            }, {
              suffixIcon: _withCtx(() => [
                _createVNode(_component_caret_down_filled)
              ]),
              _: 1
            }, 8, ["value", "options", "onSearch", "onChange", "onFocus"])
          ]),
          _createElementVNode("div", _hoisted_17, [
            _hoisted_18,
            _createVNode(_component_a_input, {
              class: "a-input",
              style: {"width":"242px"},
              value: _ctx.remarkValue,
              "onUpdate:value": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.remarkValue) = $event)),
              placeholder: "Option"
            }, null, 8, ["value"])
          ])
        ]),
        (_ctx.isError)
          ? (_openBlock(), _createBlock(_component_a_alert, {
              key: 0,
              message: _ctx.isErrorMessage,
              type: "error"
            }, null, 8, ["message"]))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_19, [
          _createElementVNode("span", {
            class: "next-button cursor-pointer p-2 w-32 text-center rounded-full",
            onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.handleSendClick && _ctx.handleSendClick(...args)))
          }, "Send")
        ])
      ])
    ]),
    _: 1
  }, 8, ["placement", "visible"]))
}